<script>
export default {
    name: 'UsersUpdatePwForm',
    props: {
        onformsubmit: {
            type: Function,
            required: true
            },
        validator: {
            type: Object,
            required: true
            },
        form: {
            type: Object,
            required: true
            }
    },
    data() {
        return {}
    },
}
</script>
<template>
    <b-form  id="form" @submit="onformsubmit" >
        <form-wrapper :validator="validator ">
        <div>
            <form-summary/>
        </div>
        <form-group name="password" :label="$t('password')">
            <b-form-input
                v-model="form.password"
                slot-scope="{ attrs, listeners }"
                type="password"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group name="repeat_password" :label="$t('repeat_password')">
            <b-form-input
                v-model="form.repeat_password"
                slot-scope="{ attrs, listeners }"
                type="password"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>          
        </form-wrapper>
    </b-form>
</template>